<div>
    <!-- Slider main container -->
    <div class="swiper-slide push-up-6" data-swiper-autoplay="2000">
        <cm-home-swiper *ngIf="discover" [banners]="discover.Banners"></cm-home-swiper>
    </div>
    <!-- end Slider main container -->

    <!-- Log Info -->
    <cm-log-info *ngIf="discover && this.screenWidth <= 768" [runningMessages]="discover.RunningMessages">
    </cm-log-info>

    <!-- Games -->
    <cm-games *ngIf="discover" [currency]="discover.Currency" [playerId]="discover.Username"
        [inGameId]="discover.InGameId" [cash]="discover.Cash"></cm-games>

    <p-dialog class="non-header" [(visible)]="displayChangePassword" [dismissableMask]="true" [draggable]="false"
        [resizable]="false" [style]="{width: '400px'}">
        <div class="align-item-center">
            <cm-change-password (close)="onCloseChangePasswordDialog()"></cm-change-password>
        </div>
    </p-dialog>

    <cm-report-dialog [visible]="displayReport" (close)="onCloseReportDialog()">
    </cm-report-dialog>
</div>